"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.execNode = void 0;
var toNumber = function (value) {
    var float = parseFloat(value);
    return isNaN(float) ? null : float;
};
var execOperator = function (ast, op, scope) {
    var left = toNumber((0, exports.execNode)(ast.left, scope));
    var right = toNumber((0, exports.execNode)(ast.right, scope));
    if (left === null || right === null) {
        throw new Error("Cannot perform ".concat(left, " ").concat(op, " ").concat(right));
    }
    switch (op) {
        default:
        case '+':
            return left + right;
        case '-':
            return left - right;
        case '*':
            return left * right;
        case '/':
            return left / right;
    }
};
var execIdentifier = function (ast, scope) {
    var target = scope.getSymbol(ast.value);
    if (target === undefined)
        throw new Error("Unknown identifier ".concat(ast.value));
    return target;
};
var execFunction = function (ast, scope) {
    var func = scope.getFunction(ast.name.value);
    if (!func)
        throw new Error("Unknown function ".concat(ast.name.value));
    // If there is only one argument, wrap it in an array
    if (!Array.isArray(ast.arguments)) {
        ast.arguments = [ast.arguments];
    }
    var args = ast.arguments.map(function (arg) { return (0, exports.execNode)(arg, scope); });
    var result = func.apply(void 0, __spreadArray([], __read(args), false));
    // eslint-disable-next-line no-console
    // console.log(ast.name.value, ...args, 'returned', result);
    return result;
};
var execNode = function (ast, scope) {
    switch (ast.type) {
        case 'add':
            return execOperator(ast, '+', scope);
        case 'subtract':
            return execOperator(ast, '-', scope);
        case 'multiply':
            return execOperator(ast, '*', scope);
        case 'divide':
            return execOperator(ast, '/', scope);
        case 'function':
            return execFunction(ast, scope);
        case 'identifier':
            return execIdentifier(ast, scope);
        case 'number':
            return ast.value;
        case 'string':
            return ast.value;
        default:
            throw new Error("Unknown AST node type: \"".concat(ast.type, "\""));
    }
};
exports.execNode = execNode;
